import { useState } from 'react';
import { Segmented } from '@/design-system/components/segmented';
import { Switch } from '@/design-system/components/switch';
import { SettingsSection } from './settings-layout';

const KEY = 'cw.reduce-motion';
export function applyMotionPreference() {
  try {
    document.documentElement.classList.toggle('cw-reduce-motion', localStorage.getItem(KEY) === '1');
  } catch {
    /* sem armazenamento */
  }
}

/** Configurações → Aparência: o produto é escuro por definição (SPEC §45); aqui, conforto. */
export function AppearanceSettings() {
  const [reduce, setReduce] = useState(() => {
    try {
      return localStorage.getItem(KEY) === '1';
    } catch {
      return false;
    }
  });
  const [density, setDensity] = useState(() => {
    try {
      return localStorage.getItem('cw.density') ?? 'normal';
    } catch {
      return 'normal';
    }
  });
  return (
    <SettingsSection
      title="Aparência"
      description="Vale para este navegador. O tema é escuro, pensado para trabalho visual."
    >
      <ul className="flex max-w-lg flex-col divide-y divide-line">
        <li className="flex items-center justify-between gap-4 py-3 text-[14px]">
          <span>
            Reduzir animações
            <span className="block text-[12.5px] text-fg-subtle">
              A linha do agora continua, sem transições e entradas animadas.
            </span>
          </span>
          <Switch
            checked={reduce}
            onCheckedChange={(v) => {
              setReduce(v);
              try {
                localStorage.setItem(KEY, v ? '1' : '0');
              } catch {
                /* ignora */
              }
              applyMotionPreference();
            }}
          />
        </li>
        <li className="flex items-center justify-between gap-4 py-3 text-[14px]">
          <span>Densidade</span>
          <Segmented
            label="Densidade"
            value={density}
            onChange={(v) => {
              setDensity(v);
              try {
                localStorage.setItem('cw.density', v);
              } catch {
                /* ignora */
              }
              document.documentElement.dataset.density = v;
            }}
            options={[
              { value: 'normal', label: 'Normal' },
              { value: 'compact', label: 'Compacta' },
            ]}
          />
        </li>
      </ul>
    </SettingsSection>
  );
}
